import React from "react";
import { connect } from "react-redux";
import { Card } from "semantic-ui-react";
import Field from "../misc/Field";
import "../../styles/dashboard.scss";

class AdminFieldsField extends React.Component {
  constructor(props) {
    super(props);
    this.fieldsContext = "Unknown Context";
    this.state = {
      open: false
    };
    this.openToggle = this.openToggle.bind(this);
  }

  openToggle() {
    this.setState({
      open: !this.state.open
    });
  }

  save() {
    // Fire off API request
  }

  render() {
    if (this.props.userRole === "admin") {
      return (
        <Card fluid>
          <Card.Content>
            <Card.Header
              style={{ fontSize: "1.1em", cursor: "pointer" }}
              onClick={this.openToggle}
            >
              {this.props.label}
            </Card.Header>
            {this.state.open ? (
              <Card.Content>
                <Field
                  type="text"
                  label="Field Label"
                  placeholder="Field Label"
                  value={this.props.label}
                />
                <Field
                  type="select"
                  label="Field Type"
                  placeholder="Field Type"
                  value={this.props.type}
                  options={[
                    { text: "Simple Text", value: "text" },
                    { text: "Long Textarea", value: "textarea" },
                    { text: "Checkbox", value: "checkbox" },
                    { text: "Dropdown Select", value: "select" },
                    { text: "Read-Only Note", value: "note" },
                    { text: "Flight", value: "flight" },
                    { text: "File Upload", value: "file" },
                    { text: "User Picker", value: "user" }
                  ]}
                />
                {this.props.type === "select" ||
                this.props.type === "checkbox" ? (
                  <Field
                    type="text"
                    label="Options"
                    multi={true}
                    value={this.props.options}
                  />
                ) : null}
                <Field
                  type="text"
                  label="Details"
                  placeholder="Details"
                  value={this.props.details}
                  details="Shows up underneath the field to provide more info (like this message)."
                />
                <Field
                  type="select"
                  label="Validation"
                  value={this.props.validation}
                  options={[
                    { text: "None", value: "" },
                    { text: "Numeric", value: "numeric" },
                    { text: "Money Format", value: "money" },
                    { text: "Date", value: "date" },
                    { text: "URL", value: "url" },
                    { text: "Email Address", value: "email" },
                    { text: "Phone", value: "phone" },
                    { text: "Flight", value: "flight" },
                    { text: "File Upload", value: "file" },
                    { text: "User", value: "user" },
                    { text: "Client Name", value: "client-name" },
                    { text: "Marketron", value: "marketron" }
                  ]}
                />
                <Field
                  type="checkbox"
                  label="Required?"
                  value={this.props.required}
                  //  options={["Yes", "No"]}
                />
              </Card.Content>
            ) : null}
          </Card.Content>
        </Card>
      );
    } else {
      return (
        <Card fluid>
          <Card.Content>
            <Card.Header>Access Denied</Card.Header>
          </Card.Content>
        </Card>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    firstName: state.main.userFirstName,
    userRole: state.main.userRole,
    userId: state.main.userId
  };
}

export default connect(mapStateToProps, null)(AdminFieldsField);



// WEBPACK FOOTER //
// ./src/components/admin/AdminFieldsField.js